// @ts-ignore
/* eslint-disable */
import request from '../../utils/request';

/** 查询用户权益领取信息 # **获取AccessToken** 
<a href='http://auth-service-beta2.shrise.cn/doc.html#/default/token-controller/generateUserAccessTokenUsingPOST' target='_blank'>点击此处获取测试站用户AccessToken</a>参数示例: 
  ```
{
  "productType": 171,
  "userId": 240
}
  ```
 GET /broker-open-equity/apply/info */
export async function brokerOpenEquityApplyInfoUsingGET(options?: { [key: string]: any }) {
  return request<API.BaseResultBrokerOpenEquityApplyInfoResp>('/broker-open-equity/apply/info', {
    method: 'GET',
    ...(options || {}),
  });
}

/** 提交用户权益包领取回访信息 # **获取AccessToken** 
<a href='http://auth-service-beta2.shrise.cn/doc.html#/default/token-controller/generateUserAccessTokenUsingPOST' target='_blank'>点击此处获取测试站用户AccessToken</a>参数示例: 
  ```
{
  "productType": 171,
  "userId": 240
}
  ```
 POST /broker-open-equity/feedback/submit */
export async function brokerOpenEquityFeedbackSubmitUsingPOST(
  body: API.BrokerOpenEquityFeedbackReq,
  options?: { [key: string]: any },
) {
  return request<API.BaseResultVoid>('/broker-open-equity/feedback/submit', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data: body,
    ...(options || {}),
  });
}

/** 权益包领取签字 # **获取AccessToken** 
<a href='http://auth-service-beta2.shrise.cn/doc.html#/default/token-controller/generateUserAccessTokenUsingPOST' target='_blank'>点击此处获取测试站用户AccessToken</a>参数示例: 
  ```
{
  "productType": 171,
  "userId": 240
}
  ```
 POST /broker-open-equity/sign */
export async function brokerOpenEquitySignUsingPOST(
  body: API.BrokerOpenEquitySignReq,
  options?: { [key: string]: any },
) {
  return request<API.BaseResultESignStatusResp>('/broker-open-equity/sign', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data: body,
    ...(options || {}),
  });
}

/** 查询权益包领取签字信息 # **获取AccessToken** 
<a href='http://auth-service-beta2.shrise.cn/doc.html#/default/token-controller/generateUserAccessTokenUsingPOST' target='_blank'>点击此处获取测试站用户AccessToken</a>参数示例: 
  ```
{
  "productType": 171,
  "userId": 240
}
  ```
 GET /broker-open-equity/sign/status */
export async function brokerOpenEquitySignStatusUsingGET(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.brokerOpenEquitySignStatusUsingGETParams,
  options?: { [key: string]: any },
) {
  return request<API.BaseResultESignStatusResp>('/broker-open-equity/sign/status', {
    method: 'GET',
    params: {
      ...params,
    },
    ...(options || {}),
  });
}

/** 提交权益包申请 # **获取AccessToken** 
<a href='http://auth-service-beta2.shrise.cn/doc.html#/default/token-controller/generateUserAccessTokenUsingPOST' target='_blank'>点击此处获取测试站用户AccessToken</a>参数示例: 
  ```
{
  "productType": 171,
  "userId": 240
}
  ```
 POST /broker-open-equity/submit */
export async function brokerOpenEquitySubmitUsingPOST(
  body: API.BrokerOpenEquityApplyReq,
  options?: { [key: string]: any },
) {
  return request<API.BaseResultVoid>('/broker-open-equity/submit', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data: body,
    ...(options || {}),
  });
}
